import { Box, MenuItem } from "@mui/material";
import ThreeDotsMenu from "components/ThreeDots/ThreeDotsMenu";
import { FormattedMessage as T } from "react-intl";

type OrganizationAdminActionsProps = {
  onView: () => void;
  onDelete?: () => void;
};

export default function OrganizationAdminActions({
  onView,
  onDelete,
}: Readonly<OrganizationAdminActionsProps>) {
  return (
    <ThreeDotsMenu>
      <MenuItem onClick={onView}>
        <T id="viewUser" />
      </MenuItem>
      <MenuItem onClick={onDelete} disabled={!onDelete}>
        <Box sx={{ color: "error.main" }}>
          <T id="deleteLabel" />
        </Box>
      </MenuItem>
    </ThreeDotsMenu>
  );
}
